// extracted by mini-css-extract-plugin
export var icon = "_ac-3";
export var subtitle = "_ac-2";
export var title = "_ac-1";
export var value = "_ac-0";